// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"wW-z","sponsoredTooltipWrapper":"xW-z","sponsoredTooltip":"yW-z","newCard":"zW-z"};